import { PropsWithChildren, memo } from 'react';

import { ZapIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

import { EVENT_TEXT } from './eventText';
import { NameAvatar } from './NameAvatar';
import { Time } from './Time';

type Props = { userId?: string; time: string; created?: string; name?: string };

export const EventWrapper = memo(
  ({ userId, time, created, name, children }: PropsWithChildren<Props>) => {
    return (
      <div className="flex flex-wrap items-center justify-center gap-2 self-stretch px-4 py-2">
        <div className="flex flex-wrap items-center justify-center gap-1">
          {userId === 'brain' && (
            <>
              <ZapIcon size={16} className="shrink-0 text-muted-foreground" />
              <span className={cn(EVENT_TEXT, 'font-semibold')}>{name}</span>
            </>
          )}
          {userId !== 'brain' && (userId || name) && <NameAvatar id={userId} name={name} />}

          {children}
          <span aria-hidden="true" className={cn(EVENT_TEXT, 'select-none')}>
            ·
          </span>
          <Time time={time} created={created} />
        </div>
      </div>
    );
  }
);

EventWrapper.displayName = 'EventWrapper';
